import useListTicket from 'app/pages/NewAccount/hooks/useListTicket';
import ListTicketLayout from 'app/pages/NewAccount/layouts/ListTicketLayout';
import {
  ListTicketViewProps,
  ListTicketViewRef,
} from 'app/pages/NewAccount/types';
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';

const ListWaitForCancelApprove = forwardRef<
  ListTicketViewRef,
  ListTicketViewProps
>(({ activeKeyTab, loading, setLoading }, ref) => {
  const isActiveCurrentTab = activeKeyTab === 'tab-5';
  const [isDisplayData, setIsDisplayData] = useState(isActiveCurrentTab);

  const {
    listTicket: listTicketWaitForCancelApprove,
    paginator,
    search,
    optionsGetListOrder,
  } = useListTicket({
    orderState: 'approved,pendingApprove',
    isActiveTab: isActiveCurrentTab,
    setLoading,
    onFinally: () => {
      setIsDisplayData(true);
    },
  });

  useImperativeHandle(ref, () => {
    return {
      search,
      getCurrentSearchOpt: () => optionsGetListOrder,
    };
  });

  useEffect(() => {
    if (!isActiveCurrentTab) setIsDisplayData(false);
  }, [isActiveCurrentTab]);

  return (
    <ListTicketLayout
      loading={loading}
      paginator={paginator}
      listTicket={isDisplayData ? listTicketWaitForCancelApprove : []}
      search={search}
      orderState="approved,pendingApprove"
      setIsLoading={setLoading}
      activeKeyTab={activeKeyTab}
    />
  );
});

export default ListWaitForCancelApprove;
